var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("common.bic.bic_onus") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "6", lg: "3", xl: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        on: {
                          click: function ($event) {
                            _vm.displayFilter = !_vm.displayFilter
                          },
                        },
                      },
                      [
                        _vm.displayFilter
                          ? _c("i", { staticClass: "fa-light fa-minus" })
                          : _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("filter.fltr")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "6", lg: "3", xl: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "6", lg: "6", xl: "4" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.actionAdd },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("common.bic.bic_onus_add"))),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "justify-content-start align-items-center",
                class: {
                  "filter-item-section": true,
                  "d-none": !_vm.displayFilter,
                },
              },
              [
                _c(
                  "b-col",
                  { staticClass: "filter-item", attrs: { lg: "3", cols: "6" } },
                  [
                    _c("span", { staticClass: "filter-item-title" }, [
                      _vm._v(_vm._s(_vm.$t("annuaire.bic"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "filter-item-content" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.BIC,
                            expression: "BIC",
                            modifiers: { trim: true },
                          },
                        ],
                        class: {
                          "filter-item-input": true,
                          "filter-item-input-complete": _vm.BIC,
                        },
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("common.global.bic"),
                        },
                        domProps: { value: _vm.BIC },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.BIC = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.displayFilter
              ? _c(
                  "b-row",
                  { staticClass: "justify-content-end" },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "mt-4 mb-5",
                        attrs: { sm: "4", lg: "2", cols: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mr-3",
                            attrs: {
                              size: "sm",
                              disabled: _vm.activateSpinner,
                            },
                            on: { click: _vm.clearFilterFields },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("filter.clr_fltr_field")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "mt-4 mb-5",
                        attrs: { sm: "4", lg: "2", cols: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            attrs: { size: "sm" },
                            on: { click: _vm.onRefresh },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.srch")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mb-5" },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "div",
                    { staticStyle: { overflow: "auto" } },
                    [
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _vm.listItemsBICOnus.length > 0
                        ? _c("b-table", {
                            key: _vm.refreshKey,
                            staticClass: "table-striped",
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              items: _vm.listItemsBICOnus,
                              fields: _vm.fields,
                              hover: "",
                              selectable: _vm.listItemsBICOnus.length > 0,
                              "empty-text": _vm.$t("common.security.no_result"),
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDir,
                            },
                            on: {
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "head-clicked": _vm.sortTable,
                              "row-selected": _vm.onRowClicked,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(edit)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-3 w-100",
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionEdit(
                                              $event,
                                              data.item.IdBICOnus
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-pencil",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(delete)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-3 w-100",
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionDelete(
                                              $event,
                                              data.item.IdBICOnus
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-trash",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          })
                        : _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("span", { staticClass: "noResult" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.no_result")) +
                                    "\n              "
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mt-5" },
              [
                _c(
                  "b-col",
                  [
                    _c("cm-pagination", {
                      attrs: {
                        maxResultsByPage: _vm.paginationObject.maxResults,
                        firstIndex: _vm.paginationObject.firstIndex,
                        nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                        refreshEvent: _vm.paginationObject.refresh,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }